module.exports = __webpack_public_path__ + "img/img4.6490d097.svg";